


























































import { defineComponent, type PropType } from "vue-demi";
import MPPromoSlider from "../MPPromoSlider/MPPromoSlider.vue";
import MPStories from "../MPStories/MPStories.vue";
import type { PageData } from "@constructor/shared-entity/type";
import getValueForProp from "../../../../helper/getValueForProp";

export default defineComponent({
  name: "MPHero",
  components: {
    MPPromoSlider,
    MPStories,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
    preview: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      activeStories: false,
    };
  },
  computed: {
    promoLink() {
      const link = getValueForProp(
        "MPSellerPromoLink",
        this.data.template.prop
      );
      return link ? link : "https://05.ru/promo/6718e5a3eae97732078d10e1/";
    },
  },
  methods: {
    openStories() {
      this.activeStories = true;
    },
    closeStories() {
      this.activeStories = false;
    },
  },
});
